import {shallowRef,readonly} from 'vue'
import {isNavigationFailure,NavigationFailureType,Router,RouteLocationRaw,RouteLocationNormalizedLoaded} from 'vue-router'

// 只刷新用户明确选择的功能正文，不刷新浏览器、登录态或顶部公共组件。
const revision=shallowRef(0)
export const functionMenuRevision=readonly(revision)
export function functionMenuPageKey(route:Pick<RouteLocationNormalizedLoaded,'path'|'query'>){
  const focus=route.query.focusMessageId?'?message='+route.query.focusMessageId:route.query.focusOrderDetailId?'?detail='+route.query.focusOrderDetailId:''
  return revision.value+':'+route.path+focus
}
export function createFunctionMenuNavigation(router:Router){
  let sequence=0,pending:{id:number;fullPath:string}|undefined
  const stop=router.afterEach((to,_from,failure)=>{
    if(!pending || pending.fullPath!==to.fullPath)return
    pending=undefined
    // 重复选择当前功能也是一次刷新；取消、权限重定向和导航错误不刷新。
    if(!failure || isNavigationFailure(failure,NavigationFailureType.duplicated))revision.value++
  })
  return {
    navigate(location:RouteLocationRaw){
      const id=++sequence
      pending={id,fullPath:router.resolve(location).fullPath}
      return router.push(location).finally(()=>{if(pending?.id===id)pending=undefined})
    },
    dispose(){pending=undefined;stop()}
  }
}
